import React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useTranslation } from 'react-i18next';
import { HrSimulation } from 'routes/HumanResourcesModule/Simulation/helpers/types';
import { SimulationTypeEnum } from 'routes/HumanResourcesModule/Simulation/helpers/constants';
import { extractRawDateYear } from 'routes/HumanResourcesModule/Simulation/helpers/dataHelpers';

type Props = {
    hrSimulation: HrSimulation;
    selectedYear: number;
    setSelectedYear: (newValue: number) => void;
};

export default function YearSelector(props: Props): React.ReactElement {
    const { t } = useTranslation();

    const { selectedYear, setSelectedYear, hrSimulation } = props;
    const yearList =
        hrSimulation.type === SimulationTypeEnum.PROJECTION
            ? [extractRawDateYear(hrSimulation.startDate)]
            : [
                  extractRawDateYear(hrSimulation.startDate),
                  extractRawDateYear(hrSimulation.endDate),
              ];

    return (
        <Box sx={{ width: '50%', backgroundColor: 'white' }}>
            <FormControl required fullWidth>
                <InputLabel>{t('humanResources.applicationYear')}</InputLabel>
                <Select
                    value={selectedYear}
                    onChange={(event) =>
                        setSelectedYear(event.target.value as number)
                    }
                    label={t('humanResources.applicationYear')}
                >
                    <MenuItem value="" disabled>
                        {t('humanResources.selectYear')}
                    </MenuItem>
                    {yearList.map((value, index) => (
                        <MenuItem value={value} key={index}>
                            {value}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
}
